tryBabble = require 'app/scripts/lib/try-babble'
l = require 'app/scripts/lib/localize'
_ = require 'underscore'
counting = require('locale').counting

module.exports = (key, count, data = {}) ->
  args = _.extend { count: String(count) }, data
  tryBabble(['counts', key, counting(count)], args)
